import React, { useContext, useState, useEffect } from "react";
import { LAButton, LAText, LAView } from "../../components";
import HTMLContent from "../../components/HTMLContent";
import ExplanationComponent from "../../components/ExplanationComponent";
import AnswerMessage from "../../components/AnswerMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { STRINGS } from "../../constant";
import { AuthContext } from "../../context/AuthProvider";
import _ from "lodash";
import { GET_COMMUNITY_SINGLE_QUESTION_DETAILS } from "../../api/community";
import { GET_APP_DOMAIN_LIST, STRING } from "../../../app_constant";
import { BundleContext } from "../../context/BundleProvider";
import { ThemeContext } from "../../context/ThemeProvider";
import BackArrowIcon from "../../components/BackArrowIcon";
import { getBookMarkColor } from "../../utils/themeUtils";
import NavBar from "../../components/NavBar";
import TabFooter from "../../components/TabFooter";
import { MixpanelContext } from "../../context/MixpanelProvider";
import CommunityPopup from "../quickSet/CommunityPopup";
import QuestionOptions from "../../components/question/QuestionOptions";
import { GET_QUESTION_FROM_ID } from "../../api/test";
import { getStudyIconBg } from "../../utils/themeUtils";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBookmark, 
  faUsers, 
  faCheck, 
  faCheckDouble,
  faChevronLeft,
  faChevronRight,
  faQuestionCircle,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import useFeatureList from "../../hooks/useFeatureList";
const Questions = () => {
  const { state } = useLocation();
  const set_id = state?.set_id ?? "";
  const lastIndex = state?.lastIndex || 0;
  const questionSet = state?.questions || [];
  const title = state?.title ?? STRINGS.study_questions_title;
  const isShowAnswer = true;
  const [quickSetState, setQuickSetState] = useState({
    selectedOpion: null,
  });
  const navigate = useNavigate();
  const {
    profile,
    questionsList,
    addQuestionScore,
    addQuestionProgress,
    isVisibleCommunity,
    addQuestionToBookmark,
    removeQuestionFromBookmark,
  } = useContext(AuthContext);
  const { theme, currentTheme } = useContext(ThemeContext);
  const { selectedCertificate } = useContext(BundleContext);
  const { trackReadinessScore } = useContext(MixpanelContext);
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  const [isLoadingCommunityData, setLoadingCommunityData] = useState(false);
  const [questions, setQuestions] = useState(questionSet);

  const [currentIndex, setCurrentIndex] = useState(lastIndex);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [savedAnswers, setSavedAnswers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isSubmitAnswer, setSubmitAnswer] = useState(false);
  const [communityQuestion, setCommunityQuestion] = useState(null);
  const [isCommunityPopup, setCommunityPopup] = useState(false);

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.01,
      boxShadow: "0px 4px 10px rgba(0,0,0,0.05)",
      transition: { type: "spring", stiffness: 400, damping: 15 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return getStudyIconBg(theme, currentTheme);
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      
    };
  };
  
  const getNavBackground = () => {
    return currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark
  };
  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  // Button animations
  const buttonVariants = {
    hover: { 
      scale: 1.05,
      boxShadow: "0px 5px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    },
    tap: { scale: 0.95 }
  };

  useEffect(() => {
    setTimeout(() => {
      if (questions.length > lastIndex) {
        setCurrentIndex(lastIndex);
      }
    }, 300);
  }, []);

  const setSelectedAnswer = (questionId, selectedOption) => {
    setQuickSetState((prev) => ({
      ...prev,
      selectedOpion: selectedOption,
    }));
  };

  useEffect(() => {
    const question = questions[currentIndex];
    if (questions?.length > currentIndex && set_id) {
      addQuestionProgress(set_id, question?.id);
    }

    const index = savedAnswers.findIndex((e) => e.question_id == question?.id);
    if (index >= 0) {
      setSelectedIndex({
        selected: savedAnswers[index].selected,
        is_from_older: true,
      });
    }

    if (isVisibleCommunity && question) {
      setCommunityQuestion(null);
      getCommunityQuestion(question?.id);
    }
  }, [currentIndex]);

  useEffect(() => {
    if (selectedIndex) {
      if (selectedIndex.is_from_older == false) {
        if (!Array.isArray(currentItem?.question?.correct_answer)) {
          onUpdateScore();
        }
      }
    }
  }, [selectedIndex]);

  async function getCommunityQuestion(id) {
    try {
      setLoadingCommunityData(true);
      const result = await GET_COMMUNITY_SINGLE_QUESTION_DETAILS(id);
      setLoadingCommunityData(false);
      if (result.data) {
        setCommunityQuestion(result.data);
      } else {
        setCommunityQuestion(null);
      }
    } catch (error) {
      setLoading(false);
      setCommunityQuestion(null);
    }
  }

  function onUpdateScore() {
    if (Array.isArray(currentItem?.question.correct_answer)) {
      if (selectedIndex && selectedIndex?.selected?.length > 0) {
        trackReadinessScore(profile?.readiness_scores?.readiness_score ?? "");

        const answers = currentItem?.question.correct_answer;
        const selected = selectedIndex?.selected;

        let isCorrect = true;
        answers.forEach((element) => {
          if (!selected.includes(element)) {
            isCorrect = false;
          }
        });

        addQuestionScore(
          currentItem?.question.id,
          currentItem?.question.topic_id,
          isCorrect
        );
      }
    } else {
      if (selectedIndex && selectedIndex.selected != "X") {
        trackReadinessScore(profile?.readiness_scores?.readiness_score ?? "");
        //UPDATE USER SCORE
        addQuestionScore(
          currentItem?.question.id,
          currentItem?.question.topic_id,
          currentItem?.question.correct_answer == selectedIndex.selected
        );
      }
    }
  }

  function getCurrentQuestion() {
    if (questions.length > currentIndex) {
      return GET_QUESTION_FROM_ID(questionsList, questions[currentIndex]?.id);
    }
    return null;
  }

  function getTopicId() {
    if (questions.length > currentIndex) {
      const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
      const array = APP_DOMAIN_LIST.find(
        (item) => item?.id == questions[currentIndex]?.topic_id
      );
      return array?.domain_name ?? "";
    }
    return "";
  }

  function onPrevious() {
    trackReadinessScore(profile?.readiness_scores?.readiness_score ?? "");
    setSelectedIndex(null);
    setSubmitAnswer(false);

    setCurrentIndex((state) => {
      return state == 0 ? 0 : state - 1;
    });
  }

  function onNext() {
    trackReadinessScore(profile?.readiness_scores?.readiness_score ?? "");
    setSelectedIndex(null);
    setSubmitAnswer(false);

    setCurrentIndex((state) => {
      return state == questions.length - 1 ? 0 : state + 1;
    });
  }

  function onBookmark() {
    if (questions.length > currentIndex) {
      const question = questions[currentIndex];
      if (isBookmark) {
        removeQuestionFromBookmark(question?.id);
      } else {
        addQuestionToBookmark(question?.id);
      }
    }
  }

  function checkBookmark() {
    if (questions.length > currentIndex) {
      const question = questions[currentIndex];
      return profile?.question_bookmarks?.includes(question?.id) ?? false;
    }
    return false;
  }

  function getCommunityQuestionPercentage() {
    if (communityQuestion && true) {
      const percentage =
        (communityQuestion?.times_answered_correct /
          communityQuestion?.times_answered) *
        100;
      if (isNaN(percentage) || !isFinite(percentage)) {
        return {
          color: theme.COLOR_RED,
          percentage: 0,
          message: STRINGS.community_popup_desc_less_50,
        };
      } else if (percentage < 50) {
        return {
          color: theme.COLOR_RED,
          percentage: 0,
          message: STRINGS.community_popup_desc_less_50,
        };
      } else if (percentage < 80) {
        return {
          color: theme.COLOR_YELLOW,
          percentage: 0,
          message: STRINGS.community_popup_desc_less_80,
        };
      } else {
        return {
          color: theme.COLOR_GREEN,
          percentage: 0,
          message: STRINGS.community_popup_desc_less_100,
        };
      }
    }

    return {
      color: theme.COLOR_RED,
      percentage: 0,
      message: STRINGS.community_popup_desc_less_50,
    };
  }
  
  const isBookmark = checkBookmark();
  const currentItem = getCurrentQuestion();
  const topic = getTopicId();
  const communitySettings = getCommunityQuestionPercentage();
  const featureList = useFeatureList();
  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={() => navigate(-1)}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1 
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          {title}
        </h1>
      </div>

      {questions?.length > 0 ? (
        <>
          {/* Question Navigation and Bookmark */}
          <div className="flex items-center justify-between mb-6">
            <div 
              className="flex items-center px-4 py-2 rounded-lg"
              style={{ 
                backgroundColor:  currentTheme == 'light' ? getNavBackground() : getIconBg(),
                color: currentTheme == 'light' ? getIconBg() : getTextColor(),
              }}
              >
              <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" style={{ color: currentTheme == 'light' ? getIconBg() : getTextColor(), }}/>
              <span className="font-bold" style={{ color: currentTheme == 'light' ? getIconBg() : getTextColor(), }}>
                {`${STRINGS.question} ${currentIndex + 1}`}
              </span>
              <span className="text-sm ml-1 text-black dark:text-white">
                / {questions.length}
              </span>
            </div>
            
            <div className="flex items-center space-x-3">
              {selectedIndex?.selected && featureList?.global.community_score && (
                <button
                  className="p-2 rounded-lg transition-colors"
                  onClick={() => setCommunityPopup(true)}
                  style={{ 
                    backgroundColor: 'rgba(0,0,0,0.05)', 
                    color: communitySettings?.color 
                  }}
                >
                  <FontAwesomeIcon icon={faUsers} className="text-xl" />
                </button>
              )}
              
              <button
                className="p-2 rounded-lg transition-colors"
                onClick={onBookmark}
                style={{ 
                  backgroundColor: 'transparent',
                  color: getBookMarkColor(currentTheme,isBookmark)
                }}
              >
                <FontAwesomeIcon 
                  icon={faBookmark} 
                  className={isBookmark ? 'text-2xl' : 'text-2xl text-gray-400'} 
                />
              </button>
            </div>
          </div>

          {currentItem ? (
            <motion.div
              className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm mb-6"
              whileHover="hover"
              variants={cardVariants}
            >
              <div style={getCardBackground(getIconBg())}>
                <div className="p-6">
                  {/* Question Content */}
                  <div className="mb-6">
                    <HTMLContent
                      index={currentItem?.question?.id}
                      htmlContent={currentItem?.question?.question}
                      className="prose dark:prose-invert max-w-none"
                    />
                  </div>

                  {/* Answer Options */}
                  <div className="grid gap-3 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                    {currentItem?.choices?.map((options, index) => {
                      const isSelected = selectedIndex
                        ? selectedIndex.selected == OPTIONS[index]
                        : false;

                      return (
                        <QuestionOptions
                          key={index + 1}
                          index={index}
                          item={options}
                          isShowAnswer={isShowAnswer}
                          correct={currentItem?.question?.correct_answer}
                          selected={selectedIndex ? selectedIndex.selected : "X"}
                          isSelected={isSelected}
                          isSubmit={isSubmitAnswer || selectedIndex?.is_from_older}
                          onPress={() => {
                            if (
                              Array.isArray(currentItem?.question?.correct_answer)
                            ) {
                              const previousSelected =
                                selectedIndex?.selected ?? [];
                              if (previousSelected.includes(OPTIONS[index])) {
                                const filter = previousSelected.filter(
                                  (e) => e != OPTIONS[index]
                                );
                                setSelectedIndex({
                                  selected: filter,
                                  is_from_older: false,
                                });
                              } else {
                                previousSelected.push(OPTIONS[index]);
                                setSelectedIndex({
                                  selected: previousSelected,
                                  is_from_older: false,
                                });
                              }
                            } else {
                              const selected = OPTIONS[index];
                              if (!selectedIndex) {
                                setSelectedIndex({
                                  selected: selected,
                                  is_from_older: false,
                                });

                                let answer = {
                                  question_id: currentItem?.question?.id,
                                  selected: selected,
                                };

                                const items = [...savedAnswers];
                                items.push(answer);
                                setSavedAnswers(items);
                              }
                            }
                          }}
                        />
                      );
                    })}
                  </div>

                  {/* Submit Button for Multi-select */}
                  {isSubmitAnswer == false &&
                    Array.isArray(currentItem?.question?.correct_answer) &&
                    selectedIndex &&
                    selectedIndex?.selected?.length > 0 &&
                    !selectedIndex?.is_from_older && (
                      <div className="flex justify-center mt-8">
                        <motion.button
                          variants={buttonVariants}
                          whileHover="hover"
                          whileTap="tap"
                          className="flex items-center px-6 py-3 rounded-lg text-white font-medium"
                          style={{ backgroundColor: getIconBg() }}
                          onClick={() => {
                            let answer = {
                              question_id: currentItem?.question?.id,
                              selected: selectedIndex.selected,
                            };

                            const items = [...savedAnswers];
                            items.push(answer);
                            setSavedAnswers(items);

                            setSubmitAnswer(true);
                            onUpdateScore();
                          }}
                        >
                          <FontAwesomeIcon icon={faCheckDouble} className="mr-2" />
                          Submit Answer
                        </motion.button>
                      </div>
                    )}

                  {/* Answer and Explanation */}
                  {isShowAnswer &&
                    selectedIndex &&
                    selectedIndex.selected != "X" &&
                    (!Array.isArray(currentItem?.question?.correct_answer) ||
                      isSubmitAnswer ||
                      (selectedIndex && selectedIndex?.is_from_older)) && (
                      <div className="mt-8 pt-6 border-t" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
                        <AnswerMessage
                          correct_answer={currentItem?.question?.correct_answer}
                          selected_answer={selectedIndex.selected}
                        />
                        <ExplanationComponent
                          explanation={currentItem.question?.explanation ?? ""}
                          topic={topic}
                          sub_domain={
                            currentItem?.question?.sub_domain
                              ? currentItem?.question?.sub_domain
                              : ""
                          }
                        />
                      </div>
                    )}
                </div>
              </div>
            </motion.div>
          ) : (
            <div className="flex items-center justify-center p-8 bg-white dark:bg-gray-800 rounded-xl" style={getCardBackground(getIconBg())}>
              <p style={{ color: getTextColor() }}>No question available</p>
            </div>
          )}

          {/* Navigation Controls */}
          <NavBar 
            theme={theme}
            currentTheme={currentTheme}
            onNext={onNext}
            onPrevious={onPrevious}
            iconBg={getIconBg()}
            currentIndex={currentIndex}
            dataSet={questions?.length ?? 0}
            navTitle="Question"
            showEnd={false}
            onEndTest={() => {}}
          />
          
        </>
      ) : (
        <div className="flex flex-col items-center justify-center h-[50vh]">
          <div 
            className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
            style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}
          >
            <FontAwesomeIcon 
              icon={faExclamationCircle} 
              className="text-4xl text-gray-400" 
            />
          </div>
          <p 
            className="text-lg text-gray-400 text-center"
          >
            {STRINGS?.no_question_boomark}
          </p>
        </div>
      )}

      {/* Community Popup */}
      <AnimatePresence>
        {isCommunityPopup && (
          <CommunityPopup
            communitySettings={communitySettings}
            onCancle={() => {
              setCommunityPopup(false);
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default Questions;